import { createSearchParams } from "react-router-dom"

import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { WithdrawaWhitelistStepUI } from "@src/widgets/onboarding/ui/tours/AccountTopUp/WithdrawaWhitelistStepUI"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

export class WithdrawalInCryptoCurrencyWhiteListStep extends TourStepBase {
  component = WithdrawaWhitelistStepUI
  name = `${ONBOARDING_TOURS.ACCOUNT_TOP_UP}_WithdrawaWhitelistStep`

  constructor() {
    super({
      highlightElements: ["#GENERATED_ID_WHITELISTFORM_FORM_VOID_1"],
      placement: TOUR_MODAL_PLACEMENTS.BOTTOM_LEFT,
    })
  }

  action() {
    return router.navigate({
      pathname: paths.settings,
      search: `?${createSearchParams({ tab: "wp" })}`,
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      pic: this.name,
      subtitle: "Step 1: Whitelist the address",
      title: "Withdrawal in Cryptocurrency",
    }
  }
}
